module.exports = __webpack_public_path__ + "static/premium_nowoczesne_zew-7ac2ef2b12ea82f84211a92c945be6a5.png";